export const DATETIME_FORMAT_SERVER_UTC = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
export const DATE_FORMAT_SERVER_UTC = 'yyyy-MM-dd';
export const DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT = 'dd MMM yyyy  HH:mm:ss';
export const DATE_FORMAT_DISPLAY_LOCAL_MOMENT = 'dd MMM yyyy';
export const TIME_FORMAT_DISPLAY_LOCAL_MOMENT_SHORT = 'HH:mm';
export const DATETIME_FORMAT_CLIENT_PORTAL_FORMAT = "MM/dd/yyyy',' t";
export const DATE_FORMAT_CLIENT_PORTAL_FORMAT = 'MM/dd/yyyy';
